module.exports = __webpack_public_path__ + "static/media/sincerely.baf065a3.jpg";